import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Languages, Menu, User, X } from "lucide-react";
import { LogoMark } from "@/lib/Logo";
import { BRAND, BRAND_SUB } from "@/lib/constants";
import { useLang } from "@/lib/i18n";
import { getSession } from "@/lib/auth";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { lang, setLang, t } = useLang();
  const session = getSession();
  const accountLink = session?.user?.role === "guest" ? "/account" : session ? "/admin" : "/login";
  const accountLabel = session?.user?.role === "guest" ? "My account" : session ? "Inbox" : "Login";
  const links = [
    [t.nav.rooms, "#rooms", "rooms"],
    [t.nav.transfers, "#transfers", "transfers"],
    [t.nav.areas, "#areas", "areas"],
    [t.nav.process, "#how", "process"],
    [t.nav.faq, "#faq", "faq"],
  ];
  return (
    <header className="topbar">
      <a className="brand" href="#home" data-testid="brand-home-link">
        <LogoMark />
        <span>
          <strong>{BRAND}</strong>
          <small>{BRAND_SUB}</small>
        </span>
      </a>
      <nav className={open ? "main-nav open" : "main-nav"} aria-label="Main navigation">
        {links.map(([label, href, key]) => (
          <a key={href} href={href} onClick={() => setOpen(false)} data-testid={`nav-${key}-link`}>
            {label}
          </a>
        ))}
        <button className="lang-toggle" onClick={() => setLang(lang === "en" ? "hi" : "en")} data-testid="lang-toggle-button">
          <Languages size={14} /> {lang === "en" ? "हिंदी" : "EN"}
        </button>
        <Link className="login-nav-btn" to={accountLink} onClick={() => setOpen(false)} data-testid="nav-login-button">
          <User size={14} /> {accountLabel}
        </Link>
        <a className="nav-cta" href="#enquiry" onClick={() => setOpen(false)} data-testid="nav-request-room-link">
          {t.nav.cta} <ArrowRight size={15} />
        </a>
      </nav>
      <button className="menu-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="mobile-menu-button">
        {open ? <X /> : <Menu />}
      </button>
    </header>
  );
};
